import { dealsApi } from '../utils/api';
import useRemoteOptions from './useRemoteOptions';

const toLeadOption = (lead) => ({
  value: Number(lead.id),
  label: lead.client_name || lead.name || `سرنخ #${lead.id}`,
  mobile: lead.mobile,
});

/** سرنخ‌ها از deals/lead-options (جستجو + صفحه‌بندی سمت سرور) */
export default function useRemoteLeadOptions({ selectedValue, pageSize } = {}) {
  return useRemoteOptions({
    fetcher: dealsApi.getLeadOptions,
    toOption: toLeadOption,
    selectedValue,
    pageSize,
  });
}
